import React, { useEffect, useState } from "react";
import { Container, Row, Col, Tab, Nav, Spinner, Button } from "react-bootstrap";
import Dashboardheader from "../directives/dashboardheader";
import {
  getBusinessReportAction,
  MatchingTeamAndNodeList,
  ShowReferralHistory,
  ShowReferralHistoryDetails,
  showsteplevelrewardAction,
} from "../Action/user.action";
import toast, { Toaster } from "react-hot-toast";
import LoyaltyBonusDetails from "./LoyaltyBonusDetails";
import { Link, useNavigate } from "react-router-dom";
import config from "../config/config";
import DataTable from "react-data-table-component";

const Matchingbonus = () => {
  const navigate = useNavigate();
  const [getreferral, setreferral] = useState([]);
  const [getnodelist, setnodelist] = useState([]);
  const [getteamlist, setteamlist] = useState([]);
  const [royaltybonuslist, setroyaltybonuslist] = useState([]);
  const [loadingTeamList, setLoadingTeamList] = useState(true); // Loading state for Team List
  const [loadingNodeList, setLoadingNodeList] = useState(true); // Loading state for Node List
  const [loadingReferralHistory, setLoadingReferralHistory] = useState(true);
  const [loadingBusinessReport, setLoadingBusinessReport] = useState(true);
  const [loadingRoyaltyBonus, setLoadingRoyaltyBonus] = useState(true); // Loading state for Royalty Bonus
  const [getreferralcount, setreferralcount] = useState(0);
  const [gettotalamountmnt, settotalamountmnt] = useState("");
  const [gettotalamountusdt, settotalamountusdt] = useState("");
  const [teamPurchase, setteamPurchase] = useState(0);
  const [totalEarening, setTotalEarening] = useState(0);
  const [loyaltyBonusDetailsStatus, setLoyaltyBonusDetailsStatus] = useState(false);
  const [loyaltyDetailsDate, setLoyaltyDetailsDate] = useState("");
  const [communityMessage, setCommunityMessage] = useState("");
  const [businessReportData, setBusinessReportData] = useState("");
  const [userRank, setUserRank] = useState("");
  const [userRankRating, setUserRankRating] = useState("");
  const [currentPage, setCurrentPage] = useState(0);

  const [bonusPage, setBonusPage] = useState(0);
  const [bonusRowsPerPage, setBonusRowsPerPage] = useState(10);

  const [nodePage, setNodePage] = useState(0);
  const [nodeRowsPerPage, setNodeRowsPerPage] = useState(10);

  const [businessPage, setBusinessPage] = useState(0);
  const [businessRowsPerPage, setBusinessRowsPerPage] = useState(10);

  const [teamPage, setTeamPage] = useState(0);
  const [teamRowsPerPage, setTeamRowsPerPage] = useState(10);


  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected);
  };

  const CurrentPageResetFunc = () => {
    setCurrentPage(0);
    handlePageChange({ selected: 0 });
  };

  useEffect(() => {
    const fetchData = async () => {
      await ReferralFunc();
      await showsteplevelFunc();
      await showmatchingandnodelistFunc("team"); // Call for team list
      await showmatchingandnodelistFunc("node"); // Call for node list
      await getBusinessReport();
    };

    fetchData();
  }, []);

  const columnsTeamList = [
    {
      name: "S.No",
      selector: (row) => row.id,
    },
    {
      name: "Email",
      selector: (row) => row.email,
    },
    {
      name: "Reffered By",
      selector: (row) => row.referred_by,
    },
//   {
//   name: "Purchase",
//   selector: (row) => `${row.user_purchase}`,
// },
    {
      name: "Joining Date",
      selector: (row) => row.created_at,
    },
  ];

  const columnsNodeList = [
    {
      name: "S.No",
      selector: (row) => row.id,
    },
    {
      name: "Email",
      selector: (row) => row.email,
    },
    {
      name: "Address",
      selector: (row) => row.bnb_address,
    },
    {
      name: "Total Business",
      selector: (row) => row.totalBusiness
    },
    {
      name: "Remaining Amount",
      cell: (row) => (
        <div
          data-toggle="tooltip"
          data-placement="top"
          title="Click Here"
          onClick={() =>
            row.remainingBalance > 0 &&
            handleBusinessExpiry(row)
          }
          className={`px-3 d-flex text-center align-items-center justify-content-center  py-1 ${row.remainingBalance > 0 &&
            "dash-gradient2"
            } text-white`}
          style={{ minWidth: "50px" }}
        >
          {row.remainingBalance}
        </div>
      ),
    },
    {
      name: "Joining Date",
      selector: (row) => row.created_at,
    },
  ];

  const columnsBonusHis = [
    // {
    //   name: "S.No",
    //   selector: (row,i) => i+1,
    // },
    {
      name: "Date",
      selector: (row) => row.datetime,
    },
    {
      name: "Email",
      selector: (row) => row.user,
    },
    {
      name: "Bonus Type",
      selector: (row) => row.bonusname,
    },
    {
      name: "NFT Id",
      selector: (row) => row.uniqueid || 'NA',
    },
    {
      name: "Community Rewards %",
      selector: (row) => row.referralPercent || 'NA',
    },
    // {
    //   name: "Amount",
    //   selector: (row) => row.usdAmount || 'NA',
    // },
    {
      name: "Amount",
      selector: (row) => `${row.amount} ${row.coinname}` || 'NA' ,
    },
  ];

 
  const columnsBusinessRep = [
    {
      name: "S.No",
      selector: (row, i) => i + 1,
      width: "80px"
    },
    {
      name: "Till Date",
      selector: (row) => row.business_date,
    },
    {
      name: "Direct Node",
      selector: (row) => row.email,
    },
    {
      name: "Team Subscription (ANANT+MNT)",
      selector: (row) => row.business_mnt,
      width: "300px"
    },
    // {
    //   name: "Team Business ",
    //   selector: (row) => row.business_usd,
    // },
    {
      name: "Team Withdrawal(ANANT)",
      selector: (row) => row.withdraw,
    },
    {
      name: "Action",
      button: true,
      cell: (row) => (
        <button
          onClick={() =>
            handleUserBusinessReport(row)
          }
          className="btn-main2 px-4"
          style={{
            cursor: "pointer",
            minHeight: 35,
          }}
        >
          View Details
        </button>
      ),
      width: "200px",
    }
  ];

  const customStyles = {
    noData: {
      style: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "white",
        backgroundColor: "transparent",
      },
    },
    rows: {
      style: {
        minHeight: "72px", // override the row height
      },
    },
    headCells: {
      style: {
        paddingLeft: "16px",
        paddingRight: "16px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontSize: "16px",
      },
    },
    headRow: {
      style: {
        borderRadius: "10px 10px 0px 0px",
        border: "none",
        color: "white",

        textAlign: "center",
        background:
          "linear-gradient(174deg, rgba(65, 210, 255, 0.25) 0%, rgba(126, 66, 255, 0.25) 47.40%, rgba(221, 63, 255, 0.25) 96.19%)",
      },
    },
    cells: {
      style: {
        paddingLeft: "16px",
        paddingRight: "16px",
        wordBreak: "break-word",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontSize: "16px",
        margin: "10px 0px"
      },

    },
    table: {
      style: {
        color: "white",
        backgroundColor: "transparent",
      },
    },
    rows: {
      style: {
        fontSize: '13px',
        fontWeight: 400,
        color: "white",
        background: "linear-gradient(99deg, rgba(83, 207, 210, 0.20) 1.29%, rgba(92, 101, 225, 0.20) 49.43%, rgba(200, 33, 156, 0.20) 107.93%)",
        minHeight: '48px',

      },
    },
    pagination: {
      style: {
        fontSize: "13px",
        minHeight: "56px",
        background: "linear-gradient(99deg, rgba(83, 207, 210, 0.20) 1.29%, rgba(92, 101, 225, 0.20) 49.43%, rgba(200, 33, 156, 0.20) 107.93%)",
        borderBottom: "none",
        color: "white",
        // borderTopColor: "#99999931",
      },
      pageButtonsStyle: {
        borderRadius: "50%",
        height: "40px",
        width: "40px",
        padding: "8px",
        margin: "px",
        cursor: "pointer",
        transition: "0.4s",

        fill: "white",
        backgroundColor: "transparent",
        "&:disabled": {
          cursor: "unset",

          fill: "white",
        },
      },
    },
  };


  const showsteplevelFunc = async () => {
    setLoadingRoyaltyBonus(true); // Set loading for royalty bonus
    try {
      let res2 = await showsteplevelrewardAction();
      if (res2.success) {
        setroyaltybonuslist(res2.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoadingRoyaltyBonus(false); // Reset loading for royalty bonus
    }
  };

  const showmatchingandnodelistFunc = async (type) => {
    if (type === "team") {
      setLoadingTeamList(true);
    } else if (type === "node") {
      setLoadingNodeList(true);
    }

    try {
      let res1 = await MatchingTeamAndNodeList();
      if (res1.success) {
        if (type === "team") {
          setteamlist(res1.data.teamList);
        } else if (type === "node") {
          setnodelist(res1.data.nodeList);
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      if (type === "team") {
        setLoadingTeamList(false);
      } else if (type === "node") {
        setLoadingNodeList(false);
      }
    }
  };

  const ReferralFunc = async () => {
    setLoadingReferralHistory(true);
    try {
      let res = await ShowReferralHistory(2);
      if (res.success) {
        setreferral(res.data.history);
        setreferralcount(res.data.statistics.TeamCount);
        setteamPurchase(res.data.statistics.teamPurchase);
        setTotalEarening(res.data.statistics.totalmatchingearning || 0);
        setCommunityMessage(res.data.statistics.community_message);
        setUserRank(res.data.statistics.user_rank);
        setUserRankRating(res.data.statistics.rank_rating);
        let totalamount = 0;
        for (let i = 0; i < res.data.history.length; i++) {
          totalamount += parseFloat(res.data.history[i].amount);
        }
        settotalamountmnt(totalamount);
        let totalamountUSDT = 0;
        for (let i = 0; i < res.data.history.length; i++) {
          totalamountUSDT += parseFloat(res.data.history[i].usdAmount);
        }
        settotalamountusdt(totalamountUSDT);
      } else {
        setreferral([]);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoadingReferralHistory(false);
    }
  };


  const handleBusinessExpiry = async (data) => {
    const jsonData = {
      node_id: data.id,
      remaining_balance: data.remainingBalance,
      totalBusiness: data.totalBusiness,
    };
    const queryString = new URLSearchParams(jsonData).toString();

    window.open(`${config.baseUrl}businessexpiry?${queryString}`, "_blank");
  };

  const handleUserBusinessReport = async (data) => {
    navigate(`${config.baseUrl}UserBusinessReport`, { state: { data } });
  };

  const getBusinessReport = async () => {
    setLoadingBusinessReport(true); // Set loading to true before fetching data
    try {
      const res = await getBusinessReportAction();
      if (res.success) {
        setBusinessReportData(res.data);
      }
    } catch (error) {
      // Handle error case
    } finally {
      setLoadingBusinessReport(false); // Set loading to false after fetching data
    }
  };

  const handleViewMoreDetails = async() => {
    let res = await ShowReferralHistoryDetails(2);
    if (res.success) {
        if (res.success) {
          setreferral(res.data.history);
        } else {

          setreferral([]);
        }
    } else {
        toast.error("Failed to fetch data");
    }
  }

  return (
    <>
      <Dashboardheader />

      <Toaster />
      <div className="position-relative">
        <div className="db1"></div>
        {/* <div className="db2"></div> */}
        {/* <div className="db3"></div> */}
        <div className="db4"></div>
        <div className="db5"></div>
        <div className="db6"></div>
        <div className="db7"></div>
        <div className="db8"></div>
        <div className="page-wrapper">
          <div className="position-relative overflow-hidden mt-5 pt-2 mb-5">
            <div className="mb-3">
              <Container className=""></Container>
            </div>
            <div className="mb-5">
              <div className="container referral">
                <div className="mr-referral-content">
                  <div className="mr-referral-block">
                    <h2 className="text-white sofia-sans" style={{ fontWeight: 600 }}>
                      Community Rewards{" "}
                    </h2>
                    <Row className="sofia-sans">
                      <Col lg={5} md={12} className="">
                        <div className="mr-referral-carditem mr-referralref-item buyform card-view1  pt-3  mb-4">
                          <div className="mr-referral-inner">
                            <div className="mr-contant-block">
                              <h4>
                                <Row className="highlight">
                                  <Col
                                    lg={5}
                                    sm={5}
                                    xs={5}
                                    className="highlight"
                                  >
                                    {" "}
                                    <p className="mb-0 sofia-sans">Rank</p>
                                  </Col>
                                  <Col lg={7} sm={7} xs={7}>
                                    <div className="d-flex align-items-center">
                                      <span className="seprator"> : </span>
                                      <p className="mb-0 sofia-sans">{userRank}</p>
                                    </div>
                                  </Col>
                                </Row>
                              </h4><h4>
                                <Row className="highlight">
                                  <Col
                                    lg={5}
                                    sm={5}
                                    xs={5}
                                    className="highlight"
                                  >
                                    {" "}
                                    <p className="mb-0 sofia-sans">Rating</p>
                                  </Col>
                                  <Col lg={7} sm={7} xs={7}>
                                    <div className="d-flex align-items-center">
                                      <span className="seprator"> : </span>
                                      <p className="mb-0 sofia-sans">{parseInt(userRankRating)}</p>
                                    </div>
                                  </Col>
                                </Row>
                              </h4>
                              <h4>
                                <Row>
                                  <Col lg={5} sm={5} xs={5}>
                                    {" "}
                                    Team Size
                                  </Col>
                                  <Col lg={7} sm={7} xs={7}>
                                    <div className="d-flex align-items-center">
                                      <span className="seprator"> : </span>
                                      <span>{getreferralcount}</span>
                                    </div>
                                  </Col>
                                </Row>
                              </h4>
                              {/* <h4>
                                <Row>
                                  <Col lg={5} sm={5} xs={5}>
                                    {" "}
                                    Team Purchase{" "}
                                  </Col>
                                  <Col lg={7} sm={7} xs={7}>
                                    <div className="d-flex align-items-center">
                                      <span className="seprator"> : </span>
                                      <span>
                                        
                                        {teamPurchase == null
                                          ? 0
                                          : teamPurchase} 
                                      </span>
                                    </div>
                                  </Col>
                                </Row>
                              </h4>
                              <h4 className="mb-0">
                                <Row>
                                  <Col lg={5} sm={5} xs={5}>
                                    {" "}
                                    Total Collection{" "}
                                  </Col>
                                  <Col lg={7} sm={7} xs={7}>
                                    <div className="d-flex align-items-center">
                                      <span className="seprator"> : </span>
                                      <span>{totalEarening} </span>
                                    </div>
                                  </Col>
                                </Row>
                              </h4> */}
                              {/* <h6 className="mt-3">
                                <Row>
                                  <Col lg={5} sm={5} xs={5}>
                                    <p className="text text-white mb-1" style={{ fontWeight: 600 }}>Note: </p>
                                  </Col>
                                  <div className="d-flex">
                                    <span

                                      style={{ fontStyle: "italic", color: "#a3a3a3" }}
                                    >
                                      {communityMessage}
                                    </span>
                                  </div>
                                </Row>
                              </h6> */}
                            </div>
                          </div>
                        </div>
                      </Col>
                      <Col lg={7} md={12} className=" ">
                        <div className="mr-referral-carditem mr-referral-item justify-content-center d-flex flex-column align-items-center buyform mb-4 card-view1 p-4">
                          <div className="mr-contant-block">
                            <img
                              src="assets/images/newdesign/new-u.png"
                              width="100%"
                              alt="ll"
                            />
                          </div>
                          <div>
                            <Link to={`${config.baseUrl}mlmtree`} class=" text-white nftbox-submit" style={{ maxWidth: "300px", width: "100%", textDecoration: "none" }}>View Tree</Link>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>

            <div className="latest_transaction mb-5">
              <Container>
                <Tab.Container
                  id="left-tabs-example"
                  defaultActiveKey="teamlist"
                >
                  <Nav variant="pills" className="">
                    <Row
                      className="text-center mb-4 sofia-sans"
                      style={{ width: "100vw" }}
                    >
                      <Col lg={4} sm={6}>
                        <Nav.Item>
                          <Nav.Link
                            eventKey="teamlist"
                            className="card-view1 customnav-link px-0"
                            onClick={CurrentPageResetFunc}
                          >
                            Team List
                          </Nav.Link>
                        </Nav.Item>
                      </Col>
                      {/* <Col lg={3} sm={6}>
                        <Nav.Item>
                          <Nav.Link
                            eventKey="nodes"
                            className="card-view1 customnav-link px-0"
                            onClick={CurrentPageResetFunc}
                          >
                            Nodes
                          </Nav.Link>
                        </Nav.Item>
                      </Col> */}
                      <Col lg={4} sm={6}>
                        <Nav.Item>
                          <Nav.Link
                            eventKey="bonushistory"
                            className="card-view1 customnav-link px-0"
                            onClick={CurrentPageResetFunc}
                          >
                            Bonus History
                          </Nav.Link>
                        </Nav.Item>
                      </Col>
                      <Col lg={4} sm={6}>
                        <Nav.Item>
                          <Nav.Link
                            eventKey="businessreport"
                            className="card-view1 customnav-link px-0"
                            onClick={CurrentPageResetFunc}
                          >
                            Business Report
                          </Nav.Link>
                        </Nav.Item>
                      </Col>
                    </Row>
                  </Nav>

                  <Tab.Content>
                    <Tab.Pane eventKey="teamlist">
                      {loadingTeamList ? ( // Check if loading
                        <div
                          className="d-flex justify-content-center align-items-center mt-3"
                          style={{ height: 50 }}
                        >
                          <Spinner
                            animation="border"
                            role="status"
                            variant="primary"
                          >
                            <span className="visually-hidden">Loading...</span>
                          </Spinner>
                        </div>
                      ) : (
                        <div className="table-responsive sofia-sans">
                          <DataTable
                            columns={columnsTeamList}
                            data={getteamlist.slice(
                              teamPage * teamRowsPerPage,
                              teamPage * teamRowsPerPage + teamRowsPerPage
                            )}
                            customStyles={customStyles}
                            pagination
                            paginationServer
                            paginationTotalRows={getteamlist.length}
                            onChangePage={(page) => setTeamPage(page - 1)}
                            onChangeRowsPerPage={(newPerPage, page) => {
                              setTeamRowsPerPage(newPerPage);
                              setTeamPage(page - 1);
                            }}
                          />
                        </div>
                      )}
                    </Tab.Pane>
                    <Tab.Pane eventKey="nodes">
                      {loadingNodeList ? ( // Check if loading
                        <div
                          className="d-flex justify-content-center align-items-center mt-3"
                          style={{ height: 50 }}
                        >
                          <Spinner
                            animation="border"
                            role="status"
                            variant="primary"
                          >
                            <span className="visually-hidden">Loading...</span>
                          </Spinner>
                        </div>
                      ) : (
                        <div className="table-responsive sofia-sans">
                          <DataTable
                            columns={columnsNodeList}
                            data={getnodelist.slice(
                              nodePage * nodeRowsPerPage,
                              nodePage * nodeRowsPerPage + nodeRowsPerPage
                            )}
                            customStyles={customStyles}
                            pagination
                            paginationServer
                            paginationTotalRows={getnodelist.length}
                            onChangePage={(page) => setNodePage(page - 1)}
                            onChangeRowsPerPage={(newPerPage, page) => {
                              setNodeRowsPerPage(newPerPage);
                              setNodePage(page - 1);
                            }}
                          />
                        </div>
                      )}
                    </Tab.Pane>
                    <Tab.Pane eventKey="bonushistory">
                      {loadingReferralHistory ? ( // Check if loading
                        <div
                          className="d-flex justify-content-center align-items-center mt-3"
                          style={{ height: 50 }}
                        >
                          <Spinner
                            animation="border"
                            role="status"
                            variant="primary"
                          >
                            <span className="visually-hidden">Loading...</span>
                          </Spinner>
                        </div>
                      ) : (
                        <div className="table-responsive sofia-sans">
                          <DataTable
                            columns={columnsBonusHis}
                            data={getreferral.slice(
                              bonusPage * bonusRowsPerPage,
                              bonusPage * bonusRowsPerPage + bonusRowsPerPage
                            )}
                            customStyles={customStyles}
                            pagination
                            paginationServer
                            paginationTotalRows={getreferral.length}
                            onChangePage={(page) => setBonusPage(page - 1)}
                            onChangeRowsPerPage={(newPerPage, page) => {
                              setBonusRowsPerPage(newPerPage);
                              setBonusPage(page - 1);
                            }}
                          />
                          {
                            (bonusPage + 1 === getreferral.length / 10) && <div className="text-center mt-3">
                              <Button variant="main2" onClick={handleViewMoreDetails} >
                                View All
                              </Button>
                            </div>
                          }
                        </div>
                      )}
                    </Tab.Pane>
                    <Tab.Pane eventKey="businessreport">
                      {!loyaltyBonusDetailsStatus && (
                        <div className="table-responsive">
                          {loadingBusinessReport ? ( // Check if loading
                            <div
                              className="d-flex justify-content-center align-items-center mt-3"
                              style={{ height: 50 }}
                            >
                              <Spinner
                                animation="border"
                                role="status"
                                variant="primary"
                              >
                                <span className="visually-hidden">
                                  Loading...
                                </span>
                              </Spinner>
                            </div>
                          ) : (
                               <div className="table-responsive sofia-sans">

                                 <DataTable
                                   columns={columnsBusinessRep}
                                   data={businessReportData.slice(
                                     businessPage * businessRowsPerPage,
                                     businessPage * businessRowsPerPage + businessRowsPerPage
                                   )}
                                   customStyles={customStyles}
                                   pagination
                                   paginationServer
                                   paginationTotalRows={businessReportData.length}
                                   onChangePage={(page) => setBusinessPage(page - 1)}
                                   onChangeRowsPerPage={(newPerPage, page) => {
                                     setBusinessRowsPerPage(newPerPage);
                                     setBusinessPage(page - 1);
                                   }}
                                 />
                               </div>
                          )}
                        </div>
                      )}
                      {loyaltyBonusDetailsStatus && (
                        <LoyaltyBonusDetails
                          loyaltyDetailsDate={loyaltyDetailsDate}
                        />
                      )}
                    </Tab.Pane>
                  </Tab.Content>
                </Tab.Container>
              </Container>
            </div>


          </div>
        </div>
      </div>

    </>
  );
};

export default Matchingbonus;
